import * as React from "react";
import Svg, { G, Path, Defs } from "react-native-svg";

function WhatsappDefault(props) {
  const { size = 20 } = props;
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <G filter="url(#prefix__filter0_d)">
        <Path
          d="M19.1 4.874C17.2 3.037 14.7 2 12.037 2 4.396 2-.403 10.28 3.413 16.865L2 22l5.28-1.377c2.3 1.243 4.183 1.133 4.762 1.206 8.861 0 13.272-10.72 7.045-16.922l.013-.033z"
          fill="#fff"
        />
      </G>
      <Path
        d="M12.056 20.126h-.018c-2.652 0-4.346-1.257-4.513-1.329L4.4 19.61l.838-3.038-.2-.312a8.224 8.224 0 01-1.263-4.384c0-7.327 8.954-10.991 14.136-5.812 5.17 5.125 1.54 14.062-5.855 14.062z"
        fill="#00D373"
      />
      <Path
        d="M16.59 13.925l-.052-.02a36.74 36.74 0 00-1.656-.723c-.511-.189-.367-.03-1.348 1.094-.146.162-.29.175-.538.062-.25-.125-1.053-.387-2.003-1.237-.74-.663-1.236-1.475-1.383-1.725-.244-.422.267-.482.732-1.362.083-.175.04-.312-.021-.437-.063-.125-.56-1.35-.768-1.838-.2-.487-.406-.425-.56-.425-.48-.042-.831-.035-1.14.287-1.345 1.478-1.006 3.003.145 4.625 2.261 2.96 3.466 3.505 5.67 4.261.595.19 1.137.163 1.566.101.479-.076 1.473-.6 1.68-1.188.213-.588.213-1.075.15-1.188-.061-.112-.225-.175-.475-.287z"
        fill="#FAFAFA"
      />
      <Defs />
    </Svg>
  );
}

export default WhatsappDefault;
